module.exports = __webpack_public_path__ + "img/12_klio_25.c43a07cc.jpg";